/**
 * Classe pour la gestion des animations et des états pour l'écran de menu ainsi que l'ouverture des sous-menu au hover.
 */
export default class FF_Screen_Menu {

  /***
  *      ####   ####  #    #  ####  ##### #####  #    #  ####  #####  ####  #####
  *     #    # #    # ##   # #        #   #    # #    # #    #   #   #    # #    #
  *     #      #    # # #  #  ####    #   #    # #    # #        #   #    # #    #
  *     #      #    # #  # #      #   #   #####  #    # #        #   #    # #####
  *      ####   ####  #    #  ####    #   #    #  ####   ####    #    ####  #    #
  */
  constructor() {

    // ========================================================================================
    // Propriétés de l'instance
    // ========================================================================================
    this.initialized = false;
    this.is_open = false;
    this.in_animation = null;
    this.out_animation = null;
    this.elements = {};
    this.main_nav_links_split_texts = [];
    this.current_page_sub_menu = null;
    this.registered_hooks = {
      on_open : [],
      on_close: []
    };
    this.hooks = {
      on_open: (cb) => {
        this.registered_hooks.on_open.push(cb);
      },
      on_close: (cb) => {
        this.registered_hooks.on_close.push(cb);
      }
    };

    // ========================================================================================
    // Initialisation
    // ========================================================================================
    this.refresh();
    this.initialized = true;
    $('body').on('click', '[data-screen-menu-toggle]', this.toggle.bind(this));
    $(document).on('keydown', (e) => {
      if (e.key !== 'Escape') return;
      this.close();
    });

    // ========================================================================================
    // Lors d'un changement de page Barba, on rafraîchit l'instance
    // ========================================================================================
    if (barba) {
      barba.hooks.beforeEnter(() => {
        this.refresh();
      });
    }

    // ========================================================================================
    // Gère l'ouverture et la fermeture (accordéon) des sous-menus au survol
    // ========================================================================================
    this.setup_sub_menus_accordions();

  }

  /***
  *     #####  ###### ###### #####  ######  ####  #    #
  *     #    # #      #      #    # #      #      #    #
  *     #    # #####  #####  #    # #####   ####  ######
  *     #####  #      #      #####  #           # #    #
  *     #    # ###### #      #    # ######  ####  #    #
  */
  /**
   * Rafraîchit les éléments de l'écran de menu et ferme instantanément le menu.
   */
  refresh() {

    // ========================================================================================
    // Éléments de l'écran de menu
    // ========================================================================================
    const $container = $('.screen-menu');
    this.elements = {
      container          : $container.get(0),
      bg                 : $container.find('.screen-menu__bg').get(0),
      navigation         : $container.find('.screen-menu__navigation').get(0),
      navigation_scroller: $container.find('.screen-menu__navigation-scroller').get(0),
      navigation_items   : $container.find('.screen-menu__navigation > ul > li > .menu-item-link-wrapper > a').toArray(),
      side_border        : $container.find('.screen-menu__side-border').get(0),
      side_navigation    : $container.find('.screen-menu__side-navigation').get(0),
      newsletter_form    : $container.find('.screen-menu__newsletter-form').get(0)
    };

    // ========================================================================================
    // Mise de l'état fermé du menu
    // ========================================================================================
    this.is_open = false;
    $(this.elements.container).removeClass('screen-menu--is-open').css('visibility', 'hidden');
    this.get_out_animation().progress(1).kill();

  }

  /***
  *     #####  ####   ####   ####  #      ######
  *       #   #    # #    # #    # #      #
  *       #   #    # #      #      #      #####
  *       #   #    # #  ### #  ### #      #
  *       #    ####   ####   ####  ###### ######
  */
  /**
   * Selon l'état actuel d'affichage, ouvre ou ferme l'écran de menu.
   *
   * @returns {Promise} Promise qui sera résolu lorsque les animations seront terminées.
   */
  toggle() {
    return new Promise(async (resolve) => {
      await this[this.is_open ? 'close' : 'open']();
      resolve();
    });
  }

  /***
  *      ####  #####  ###### #    #
  *     #    # #    # #      ##   #
  *     #    # #    # #####  # #  #
  *     #    # #####  #      #  # #
  *      ####  #      ###### #    #
  */
  /**
   * Ouvre l'écran de menu.
   *
   * @param {Boolean} instant Si oui ou non l'ouverture doit se faire instantanément.
   * @returns {Promise} Promise qui sera résolu lorsque les animations seront terminées.
   */
  open(instant = false) {
    return new Promise(async (resolve) => {
      if (!this.is_open) {

        $(this.elements.container).css('visibility', 'visible');

        // Hooks
        this.registered_hooks.on_open.forEach((cb) => cb());

        // Réactive le focus par tabulation pour les éléments intéractifs
        $(this.elements.container).find('a, button, input, select, textarea').attr('tabindex', '');

        // Si une bannière (FF WP Alerts) en relative  se trouve sur la page, on ajuste la barre du haut du header pour retirer le offset qu'elle pourrait avoir
        if ($('.ff-banner--relative').get(0) && ff_scroll.get_scroll_top() <= $('.ff-banner--relative').innerHeight()) {
          gsap.to('.header__top-container', { top: -Math.min($('.ff-banner--relative').innerHeight() - ff_scroll.get_scroll_top(), $('.ff-banner--relative').innerHeight()), duration: 0.75, ease: 'custom.inOutSlowOut' });
        }

        // Si une bannière (FF WP Alerts) en en "fixed-top" se trouve sur la page, on ajuste la barre du haut du header pour retirer le offset qu'elle pourrait avoir
        if ($('.ff-banner--fixed-top').get(0)) {
          gsap.to('.header__top-container', { top: -$('.ff-banner--fixed-top').innerHeight(), duration: 0.75, ease: 'custom.inOutSlowOut' });
        }

        // Stoppe le scroll
        ff_scroll.lock_scroll();

        // Animation
        const animation = this.get_in_animation();
        if (instant) {
          animation.progress(1);
        }
        else {
          await animation.play();
        }

        // Met à jour les data de prevent de Lenis
        setTimeout(() => {
          ff_scroll.update_lenis_prevent_elements();
        });

      }
      resolve();
    });
  }

  /***
  *      ####  #       ####   ####  ######
  *     #    # #      #    # #      #
  *     #      #      #    #  ####  #####
  *     #      #      #    #      # #
  *      ####  ######  ####   ####  ######
  */
  /**
   * Ferme l'écran de menu.
   *
   * @param {Boolean} instant Si oui ou non la fermeture doit se faire instantanément.
   * @returns {Promise} Promise qui sera résolu lorsque les animations seront terminées.
   */
  close(instant = false, is_page_transition = false) {
    return new Promise(async (resolve) => {
      if (this.is_open) {

        // Hooks
        this.registered_hooks.on_close.forEach((cb) => cb());

        // Désactive le focus par tabulation pour les éléments intéractifs
        $(this.elements.container).find('a, button, input, select, textarea').attr('tabindex', '-1');

        // S'assure de reset le offset top de la barre du haut du header donné dans open() si une bannière (FF WP Alerts) en relative se trouve sur la page
        if (gsap.getProperty('.header__top-container', 'top') !== 0 && !$('html').hasClass('barba-transitioning')) {
          gsap.to('.header__top-container', { top: 0, duration: 0.85, ease: 'custom.inOutSlowOut', clearProps: 'top' });
        }

        // Ferme les sous-menus ouverts
        $(this.elements.navigation).find('.sub-menu--open').each((i, sub_menu) => {
          if (sub_menu === this.current_page_sub_menu) return;
          this.close_sub_menu(sub_menu);
        });

        // Réactive le scroll
        if (this.initialized && $('html').hasClass('first-load-anim-completed') && ff_scroll.lenis.isStopped) {
          ff_scroll.unlock_scroll();
        }

        // Animation
        const animation = this.get_out_animation(is_page_transition);
        if (instant) {
          animation.progress(1);
        }
        else {
          await animation.play();
        }
        $(this.elements.container).css('visibility', 'hidden');

      }
      resolve();
    });
  }

  /***
  *      ####  ###### #####    # #    #      ##   #    # # #    #   ##   ##### #  ####  #    #
  *     #    # #        #      # ##   #     #  #  ##   # # ##  ##  #  #    #   # #    # ##   #
  *     #      #####    #      # # #  #    #    # # #  # # # ## # #    #   #   # #    # # #  #
  *     #  ### #        #      # #  # #    ###### #  # # # #    # ######   #   # #    # #  # #
  *      ####  ######   #      # #    #    #    # #    # # #    # #    #   #   #  ####  #    #
  */
  /**
   * Initialise et retourne la timeline d'animations d'ouverture.
   *
   * @returns {object} Timeline GSAP des animations.
   */
  get_in_animation() {

    // Configuration de la timeline
    const tl = gsap.timeline({
      defaults: { duration: 0.6, ease: 'Expo.easeOut' },
      paused  : true,
      onStart : () => {
        if (this.in_animation) this.in_animation.kill();
        if (this.out_animation) this.out_animation.kill();
        this.in_animation = tl;
        this.out_animation = null;
        this.is_open = true;
        $(this.elements.container).addClass('screen-menu--is-opening screen-menu--is-open');
        $(this.elements.container).removeClass('screen-menu--is-closing');
        $('html').addClass('screen-menu-is-open');
      },
      onComplete: () => {
        $(this.elements.container).removeClass('screen-menu--is-opening');
        this.in_animation = null;
      }
    });

    // Animation simplifié
    if (limit_animations) {
      tl.to(this.elements.container, { opacity: 1, duration: 0.6, ease: 'custom.inOutSlowOut' }, 0);
      if (this.current_page_sub_menu) {
        tl.add(this.open_sub_menu(this.current_page_sub_menu), 0.4);
      }
      return tl;
    }

    // Animations
    tl.to(this.elements.bg, { opacity: 1, duration: 0.7, ease: 'custom.inOutSlowOut' }, 0);
    tl.to(this.elements.navigation_items, { y: 0, duration: 1.2, ease: 'expo.out', stagger: 0.09 }, 0.15);
    if (this.current_page_sub_menu) {
      const current_page_item_index = $(this.current_page_sub_menu).closest('.menu-item').index();
      tl.add(this.open_sub_menu(this.current_page_sub_menu), `<${0.175 + (current_page_item_index * 0.09)}`);
    }
    if (!gsap.isTweening(this.elements.side_border)) {
      tl.set(this.elements.side_border, { [!is_phone_display ? 'scaleX' : 'scaleY']: 1, transformOrigin: is_phone_display ? 'left center' : 'top center' }, 0.15);
    }
    tl.to(this.elements.side_border, { [is_phone_display ? 'scaleX' : 'scaleY']: 1, duration: 1.2, ease: 'expo.inOut' }, '<');
    tl.to($(this.elements.side_navigation).find('.u-simple-list__title, .u-simple-list__list > li'), { x: 0, duration: 1.1, ease: 'expo.out', stagger: 0.07 }, '<+0.6');
    tl.to(this.elements.newsletter_form, { y: 0, duration: 1.2, ease: 'expo.out' }, '<+0.1');

    return tl;
  }


  /***
  *      ####  ###### #####     ####  #    # #####      ##   #    # # #    #   ##   ##### #  ####  #    #
  *     #    # #        #      #    # #    #   #       #  #  ##   # # ##  ##  #  #    #   # #    # ##   #
  *     #      #####    #      #    # #    #   #      #    # # #  # # # ## # #    #   #   # #    # # #  #
  *     #  ### #        #      #    # #    #   #      ###### #  # # # #    # ######   #   # #    # #  # #
  *      ####  ######   #       ####   ####    #      #    # #    # # #    # #    #   #   #  ####  #    #
  */
  /**
   * Initialise et retourne la timeline d'animation de fermeture.
   *
   * @returns {object} Timeline GSAP des animations.
   */
  get_out_animation() {

    // Configuration de la timeline
    const tl = gsap.timeline({
      paused : true,
      onStart: () => {
        if (this.in_animation) this.in_animation.kill();
        if (this.out_animation) this.out_animation.kill();
        this.out_animation = tl;
        this.in_animation = null;
        this.is_open = false;
        $(this.elements.container).addClass('screen-menu--is-closing').removeClass('screen-menu--is-open screen-menu--is-opening');
        $('html').removeClass('screen-menu-is-open');
      },
      onComplete: () => {
        $(this.elements.container).removeClass('screen-menu--is-closing');
        this.out_animation = null;
        $(this.elements.navigation_scroller).scrollTop(0); // Reset le scroll de la navigation
      }
    });


    // Animation simplifié
    if (limit_animations) {
      tl.to(this.elements.container, { opacity: 0, duration: 0.45, ease: 'custom.inOutSlowOut' }, 0);
      if (this.current_page_sub_menu) {
        tl.add(this.close_sub_menu(this.current_page_sub_menu), 0);
      }
      return tl;
    }

    // Animations
    tl.to(this.elements.navigation_items, { y: '100%', duration: 0.6, ease: 'power4.in' }, 0);
    tl.to(this.elements.bg, { opacity: 0, duration: 0.7, ease: 'custom.inOutSlowOut' }, 0.45);
    if (this.current_page_sub_menu) {
      tl.add(this.close_sub_menu(this.current_page_sub_menu), 0);
    }
    if (!gsap.isTweening(this.elements.side_border)) {
      tl.set(this.elements.side_border, { transformOrigin: is_phone_display ? 'left center' : 'bottom center' }, 0);
    }
    tl.to(this.elements.side_border, { [is_phone_display ? 'scaleX' : 'scaleY']: 0, duration: 1, ease: 'expo.inOut' }, '<');
    tl.to($(this.elements.side_navigation).find('.u-simple-list__title, .u-simple-list__list > li'), { x: '-100%', duration: 0.45, ease: 'power3.in' }, '<');
    tl.to(this.elements.newsletter_form, { y: '140%', duration: 0.7, ease: 'power4.in' }, '<');

    return tl;
  }

  /***
   *      ####  ###### ##### #    # #####      ####  #    # #####     #    # ###### #    # #    #  ####       ##    ####   ####   ####  #####  #####  #  ####  #    #  ####
   *     #      #        #   #    # #    #    #      #    # #    #    ##  ## #      ##   # #    # #          #  #  #    # #    # #    # #    # #    # # #    # ##   # #
   *      ####  #####    #   #    # #    #     ####  #    # #####     # ## # #####  # #  # #    #  ####     #    # #      #      #    # #    # #    # # #    # # #  #  ####
   *          # #        #   #    # #####          # #    # #    #    #    # #      #  # # #    #      #    ###### #      #      #    # #####  #    # # #    # #  # #      #
   *      ####  ######   #    ####  #          ####   ####  #####     #    # ###### #    #  ####   ####     #    #  ####   ####   ####  #    # #####  #  ####  #    #  ####
   */
  /**
   * Initialise les écouteurs d'événements qui ouvre ou ferme les accordéons de menu au survol.
   */
  setup_sub_menus_accordions() {

    // ===============================================================================================================
    // Pour tous les sous-menus, on store leur hauteurs par défaut et ouvre le sous-menu de la page actuelle par défaut
    // ===============================================================================================================
    const update = () => {

      $(this.elements.navigation).find('.sub-menu--open').removeClass('sub-menu--open');
      $(this.elements.navigation).find('.menu-item--sub-menu-open').removeClass('menu-item--sub-menu-open');

      // Hauteurs des sous-menu
      $(this.elements.navigation).find('.sub-menu').each((i, sub_menu) => {
        gsap.killTweensOf(sub_menu);
        gsap.set(sub_menu, { clearProps: 'height' });
        sub_menu.ff_initial_height = $(sub_menu).innerHeight();
        setTimeout(() => gsap.set(sub_menu, { height: 1 }));
      });

    };

    update();
    $(window).on('resize', $.debounce(update, 300)); // Mise à jour au resize
    barba.hooks.beforeEnter((data) => { // Mise à jour au changement de page Barba
      if (!data.current.container) return;
      const initial_opacity = gsap.getProperty(this.elements.container, 'opacity');
      gsap.set(this.elements.container, { opacity: 0 }); // *Cache temporairement le menu pour éviter de voir le flash des éléments de menu lors de update()
      update();
      if (initial_opacity !== 0) {
        setTimeout(() => gsap.set(this.elements.container, { clearProps: 'opacity' }));
      }
    });


    // ===============================================================================================================
    // Ajout des écouteurs d'événements
    // ===============================================================================================================
    // Pour les appareils "touch", on ajoute un écouteur au clic
    if (is_touch_device) {
      const menu_items_selector = '.screen-menu__navigation .menu > .menu-item.menu-item-has-children > .menu-item-link-wrapper > a';
      $('body').on('click', menu_items_selector, (e) => {
        const sub_menu = $(e.currentTarget).closest('.menu-item').find('.sub-menu').get(0);
        if (!sub_menu) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($(sub_menu).hasClass('sub-menu--open')) {
          this.close_sub_menu(sub_menu);
        }
        else {
          this.open_sub_menu(sub_menu);
        }
      });
      $('body').on('click', '.screen-menu', () => { // Lors d'un clic sur hors d'un lien (Dans l'écran de menu) on ferme tous les sous-menus ouverts
        $(this.elements.navigation).find('.sub-menu--open').each((i, sub_menu) => {
          if (sub_menu === this.current_page_sub_menu) return;
          this.close_sub_menu(sub_menu);
        });
      });
    }

    // Sinon, on le gère au hover avec la souris
    else {
      const menu_items_selector = '.screen-menu__navigation .menu > .menu-item.menu-item-has-children';
      $('body')
        .on('mouseenter', menu_items_selector, (e) => this.open_sub_menu($(e.currentTarget).find('.sub-menu').get(0)))
        .on('mouseleave', menu_items_selector, (e) => {
          if ($(e.currentTarget).find('.sub-menu').get(0) === this.current_page_sub_menu) return;
          this.close_sub_menu($(e.currentTarget).find('.sub-menu').get(0));
        });
    }

  }

  /***
   *      ####  #####  ###### #    #     ####  #    # #####     #    # ###### #    # #    #
   *     #    # #    # #      ##   #    #      #    # #    #    ##  ## #      ##   # #    #
   *     #    # #    # #####  # #  #     ####  #    # #####     # ## # #####  # #  # #    #
   *     #    # #####  #      #  # #         # #    # #    #    #    # #      #  # # #    #
   *      ####  #      ###### #    #     ####   ####  #####     #    # ###### #    #  ####
   */
  /**
   * Ouvre un sous-menu.
   * @param {HTMLElement} sub_menu Élément du sous-menu à ouvrir.
   * @returns {Object} Animation d'ouverture.
   */
  open_sub_menu(sub_menu) {

    if (!sub_menu || typeof sub_menu.ff_initial_height === 'undefined' || $(sub_menu).hasClass('sub-menu--open')) {
      return false;
    }

    // Fermeture de tous les autre sous-menus
    $(this.elements.navigation).find('.menu-item .sub-menu--open').each((i, element) => this.close_sub_menu(element)); // eslint-disable-line no-use-before-define

    // Ouverture
    gsap.killTweensOf(sub_menu);
    return gsap.to(sub_menu, {
      height  : sub_menu.ff_initial_height,
      duration: 0.8,
      ease    : 'power4.out',
      onStart : () => {
        $(sub_menu).closest('.menu-item').addClass('menu-item--sub-menu-open');
        $(sub_menu).addClass('sub-menu--open');
      }
    });

  }

  /***
   *      ####  #       ####   ####  ######     ####  #    # #####     #    # ###### #    # #    #
   *     #    # #      #    # #      #         #      #    # #    #    ##  ## #      ##   # #    #
   *     #      #      #    #  ####  #####      ####  #    # #####     # ## # #####  # #  # #    #
   *     #      #      #    #      # #              # #    # #    #    #    # #      #  # # #    #
   *      ####  ######  ####   ####  ######     ####   ####  #####     #    # ###### #    #  ####
   */
  /**
   * Ferme un sous-menu.
   * @param {HTMLElement} sub_menu Élément du sous-menu à ferme.
   * @returns {Object} Animation de fermeture.
   */
  close_sub_menu(sub_menu) {
    gsap.killTweensOf(sub_menu);
    return gsap.to(sub_menu, {
      height  : 1,
      duration: 0.8,
      ease    : 'power4.out',
      onStart : () => {
        $(sub_menu).closest('.menu-item').removeClass('menu-item--sub-menu-open');
        $(sub_menu).removeClass('sub-menu--open');
      }
    });
  }

}
